<template>
  <div>
  <vue-header/>
    <div class="wd-container" style="margin-top: 15px;text-align:left;">
      <div class="container">
        <loading :active.sync="isLoading"
          :can-cancel="false"
          :width = "50"
          :height = "50"
          :is-full-page="false">
          </loading>
          <router-link to="/timesheets" tag="button">
         <i class="fa fa-arrow-circle-left" style="font-size:25px;margin-bottom:10px;cursor:pointer;" ></i>
          </router-link>

          <div class="card">

            <div class="card-header bg-dark text-white" v-if="timeSheet" style="text-align:center;">
              <h1 style="font-size:18px;">Add/Edit Timesheets</h1>
              <small style="font-weight: normal;font-size: 13px;">(Period
              {{moment(timeSheet.period_start,'YYYY-MM-DD').format('MM/DD/YYYY')}} -
              {{moment(timeSheet.period_end,'YYYY-MM-DD').format('MM/DD/YYYY')}})
            </small>
            </div>
            <div class="card-body">

              <table id="curtable" class="display responsive nowrap">
                <thead>
                      <tr>
                          <th>Time In</th>
                          <th>Time Out</th>
                          <th>Break (Mins)</th>
                          <th>Total Hours</th>
                          <th>Job Name</th>
                          <th>Task Category</th>
                          <th>Rework</th>
                          <th>Description</th>
                          <th>Action</th>
                          <th></th>
                      </tr>
                  </thead>
              </table>
              <div class="btn-group-fab" role="group" aria-label="FAB Menu">
                <div>
                  <button @click="addTimeSheet" type="button" class="btn btn-main btn-primary has-tooltip" data-placement="left" title="Menu"> <i class="fa fa-plus" style="margin: 5px 0px 0px 0px;"></i> </button>
                </div>
              </div>
            </div>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
let min_date = '';
let max_date ='';
import Vue from 'vue';
import CommonConstants from '@/constants/constants.js'
import moment from 'moment'
import Loading from 'vue-loading-overlay';
export default {
  components: {Loading},
  data() {
    return {
      constants: CommonConstants,
      header: {},
      moment: moment,
      isLoading: true,
      timesheetsData:[],
      timeSheet :[],
      isPending :'',
      isApproved: 0,
      title : 'a'

    }
  },
  mounted : function(){
    let self = this;
    self.header = {
        'Content-type': "application/json",
        'token': localStorage.getItem('token')
    }
    self.loadDT();
    self.getAllTimesheets();
    self.editTimeSheet();
    self.deleteTimeSheet();
  },
  methods :{
    dateConvert : function (params) {
      return moment(params, 'YYYY-MM-DD HH:mm:ss').format('MM/DD/YYYY, hh:mm a');
    },
    getAllTimesheets: function () {
        let self = this
        axios.get(self.constants.api_url + 'timesheet/view/' + self.$route.params.id, {headers:self.header})
          .then(function (response) {
            if (response.data.flag) {
              self.timesheetsData = response.data.data.timesheet_details;
              min_date = self.timesheetsData.period_start;
              max_date = self.timesheetsData.period_end;
              self.timeSheet = response.data.data.timesheet
            }
          })
          .catch(function (error) {
            self.isLoading = false
          })
          .finally(function (e) {
            self.isLoading = false
          })
      },
    loadDT (){
      var self = this;
      self.isLoading = true;
      $("#curtable").DataTable({
        serverSide: true,
        responsive: {
            details: {
                type: 'column',
                target: -1,
                renderer: function ( api, rowIdx, columns ) {
                    var data = $.map( columns, function ( col, i ) {
                      if(col.title =='Job Name' || col.title =='Description'){
                        return col.hidden ?
                            '<tr data-dt-row="'+col.rowIndex+'" data-dt-column="'+col.columnIndex+'">'+
                                '<td><b>'+col.title+':'+'</b></td> '+
                                '<td style="white-space: normal;">'+col.data+'</td>'+
                            '</tr>' :
                            '';
                      }else{
                         return col.hidden ?
                            '<tr data-dt-row="'+col.rowIndex+'" data-dt-column="'+col.columnIndex+'">'+
                                '<td><b>'+col.title+':'+'<b></td> '+
                                '<td >'+col.data+'</td>'+
                            '</tr>' :
                            '';
                      }
                    } ).join('');

                    return data ?
                        $('<table/>').append( data ) :
                        false;
                }
            }
        },
        "ordering": false,
        columnDefs: [ {
            className: 'control',
            orderable: false,
            targets:   -1,
        },
        ],
        "initComplete": function( settings, json ) {
          self.isLoading = false;
        },
        "dom": '<"top">rit<"bottom"p><"clear">',
        "paging":   false,
        destroy: true,
        orderClasses: false,
        language: {
          emptyTable: "No data available.",
          search: "INPUT",
          searchPlaceholder: "Search records",
          oPaginate: {
            sNext: '<i class="fas fa-angle-double-right"></i>',
            sPrevious: '<i class="fas fa-angle-double-left"></i>'
          },
          sLengthMenu:
            "<label class='label_dropdown_dt'>Per page</label> MENU"
        },
        ajax: {
          headers: self.header,
          url: self.constants.api_url + "timesheet_pwa/view/" + self.$route.params.id,
          type: "POST",
          dataType: "json",
          dataSrc: function (result) {
            self.allTagsModel = result.data;
            return self.allTagsModel;
          }
        },
        columns: [
          {
            render: function(data, type, full, meta) {
              return moment(full.date_in, 'YYYY-MM-DD HH:mm:ss').format('MM/DD/YYYY, hh:mm a');

            }
          },
          {
            render: function(data, type, full, meta) {
              return moment(full.date_out, 'YYYY-MM-DD HH:mm:ss').format('MM/DD/YYYY, hh:mm a');

            }
          },
          { data: "break" },
          { data: "total" },
          { data: "job_name" },
          { data: "task" },
          { data: "rework" },
          { data: "description" },
          {
            render: function(data, type, full, meta) {
              return (
                '<button type="button" id="edit_button" data-log-id="'+ full.edit +'" class="btn btn-info btn-sm" style="border-radius: 0.25rem !important;margin-right:5px;">Edit</button>&nbsp;&nbsp;&nbsp;&nbsp;<button  id="delete_button" data-log-id="'+ full.edit +'" type="button" class="btn btn-danger btn-sm" style="border-radius: 0.25rem !important;">Delete</button>'
              );
            }
          },
          {
            render: function(data, type, full, meta) {
              return (
                ''
              );
            }
          }
        ]
      });
      $("#curtable").on("page.dt", function() {
        $("html, body").animate({ scrollTop: 0 }, "slow");
        $("th:first-child").focus();
      });
    },
    addTimeSheet (){
      this.$router.push('/timesheets/'+this.$route.params.id+'/add')
    },
    editTimeSheet (){
      let self = this;
      $(document).on("click","#edit_button", function (e) {
        let id = $(e.target).data('log-id');
        self.$router.push('/timesheets/'+self.$route.params.id+'/add/'+id, () => {})
      })
    },
    deleteTimeSheet (){
      let self = this;
      $(document).on("click","#delete_button", function (e) {
        let id = $(e.target).data('log-id');
        self.deleteTimeSheetById(id)
      })
    },
    deleteTimeSheetById (id){
      let self = this
        this.$vueConfirm.confirm(
        {
          message: `Are you sure you want to permanently delete this record?`,
          button: {
            no: 'No',
            yes: 'Yes'
          }
          },
            function(confirm) {
              if (confirm == true) {

                axios.get(self.constants.api_url + "timesheet-pwa/delete/"+ id, {headers: self.header})
                .then(function (response) {
                  if (response.data == "done") {
                    self.loadDT();
                    Vue.$toast.success('Record Deleted', {
                    position: 'top'
                    });

                  } else {
                    Vue.$toast.error("Unable to delete", {
                      position: 'top'
                      });
                  }
                })
                .catch(function (error) {
                  Vue.$toast.success(error, {
                      position: 'top'
                      });
                })
              }
            }
    );
    }
  }
}
</script>

<style>

</style>
